import React from 'react';
import TypographyContainer from '../../Componant/UiKits/Typography';

const Typography = () => {
  return (
    <div className='page-body'>
      <TypographyContainer />
    </div>
  );
};

export default Typography;
